<template>

</template>

<script>
import {defineComponent} from 'vue'
import {resetPostHog} from '@/utils/posthog';

export default defineComponent({
  name: 'Logout',
  created() {
    return this.$store.dispatch('auth/logout').then(() => {
      resetPostHog();
      window.location = `${import.meta.env.VITE_APP_APP_URL}/auth/login`;
    });
  },
})
</script>

<style scoped lang="scss">

</style>
